<template>
    <div class="product_row">
        <nuxt-link class="product_card" :to="url">
            <div v-if="!isAvailable" class="strip_line">
                לא במלאי
            </div>
            <div class="top_section">
                <div class="product_image">
                    <div
                        v-full-background-image-path="product.featuredImage"
                        class="image bg_image contain"
                    />
                </div>
                <div class="product_info">
                    <div class="product_title">
                        {{ product.name }}
                    </div>
                    <div class="product_excerpt">
                        {{ product.description }}
                    </div>
                </div>
            </div>
            <div class="bottom_section">
                <div v-if="!isLoan" class="price">
                    <span>מחיר לסטודנט:</span>
                    <span>{{ product.price | formatPrice }}</span>
                </div>
                <div v-if="!isLoan" class="price_member">
                    <span>לחברי האגודה:</span>
                    <span>{{ agudaPrice | formatPrice }}</span>
                </div>
            </div>
        </nuxt-link>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true
        },

        isLoan: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        url() {
            return `/${this.isLoan ? 'loan-' : ''}products/${
                this.product.slug
            }`;
        },

        agudaPrice() {
            return this.product.agudaPrice || this.product.price;
        },

        isAvailable() {
            if (this.isLoan) {
                return !!this.product.stockAmount;
            }

            return this.product.variants.some(
                ({ stockAmount }) => stockAmount > 0
            );
        }
    }
};
</script>
